module.exports = __webpack_public_path__ + "static/media/default-image.134e3778.png";